import React, { useEffect } from 'react';

import _ from 'lodash';
import { Redirect, Switch } from 'react-router';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { usePropsCallback } from 'hooks';
import { refreshToken } from 'store/modules/auth';
import { routes } from 'routes/Dashboard';
import { hasAnyRole } from 'utils/credentials';
import Menubar from './Menubar';
import Topbar from './Topbar';

import withRoot from 'hoc/withRoot';

import styles from './Dashboard.module.scss';

const Dashboard = ({ auth, match, refreshToken }) => {
  const refresh = usePropsCallback(refreshToken);

  useEffect(() => {
    const timer = setInterval(refresh, 600000); // 10 minutes

    return () => {
      clearInterval(timer);
    };
  }, [refresh]);

  if (!auth.user) {
    return <Redirect to="/login" />;
  }

  const roles = _.get(auth, 'currentGroup.myRoles', []);

  return (
    <div className={styles.dashboard} key={_.get(auth, 'currentGroup._id')}>
      <div className={styles.left}>
        <Menubar />
      </div>

      <div className={styles.center}>
        <Topbar />

        <div id="_viewport_" className={styles.content}>
          <div id="_scroll_panel_">
            <Switch>
              <Route path={match.url} exact component={null} />

              {roles
                ? routes.map(({ path, component, allow, disabled }) =>
                    !disabled && hasAnyRole(allow, roles) ? (
                      <Route
                        key={path}
                        path={`${match.url}/${path}`}
                        component={component}
                      />
                    ) : null
                  )
                : null}

              <Redirect to="/dashboard" />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRoot(connect(({ auth }) => ({ auth }), { refreshToken })(Dashboard));
